export const receivedUserDetails = (details) => ({
    type: 'USER_DETAILS',
    isAuthenticated: details.authenticated,
    name: details.authenticated ? details.name : 'Anonymous',
    email: details.authenticated ? details.email : 'Anonymous',
    conditionsAccepted: details.conditionsAccepted
});
